<template>
  <div class="home-wrapper">
    <div class="home">
      <div class="user-bar">
        <user-profile :user="user"></user-profile>
        <div class="quote-card" v-show="currentComponent != 'new-quote'">
          <div class="card-title">Agendar cotización</div>
          <div class="card-description">Agenda una cotización con el equipo de Coloquearte</div>
          <div class="button button-desktop" @click="() => { currentComponent = 'new-quote' }">
            Agendar
          </div>
          <div class="button button-mobile" @click="$router.push('/quote')">
            Agendar
          </div>
        </div>
      </div>
      <div class="main" >
        <component
          v-if="user.id"
          v-bind:is="currentComponent"
          @close="() => { currentComponent = 'records' }">
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import UserProfile from '@/components/UserProfile.vue';
import Records from '@/components/Records.vue';
import NewQuote from '@/components/NewQuote.vue';

const { mapState } = createNamespacedHelpers('user');

export default {
  name: 'home',
  data() {
    return {
      currentComponent: 'records',
    };
  },
  components: {
    UserProfile,
    Records,
    NewQuote,
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.home-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
}
.home {
  width: 900px;
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
}
.user-bar {
  width: 34%;
}
.main {
  width: 64%;
}
.quote-card {
  width: 100%;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.25);
  margin-top: 20px;
  background-color: white;
  border-radius: 6px;
  padding: 16px;
}
.card-title {
  font-size: 20px;
}
.card-description {
  margin: 10px 0 18px 0;
}
.button {
  background-image: linear-gradient(to right, #f6d365 0%, #f79916 51%, #f6d365 100%);
  display: flex;
  justify-content: center;
  padding: 14px;
  color: white;
  border-radius: 6px;
  cursor: pointer;
}
.button-mobile {
  display: none !important;
}
@media only screen and (max-width: 920px) {
  .home {
    width: 95%;
  }
  .main {
    display: none;
  }
  .user-bar {
    width: 100%;
  }
  .button-desktop {
    display: none;
  }
  .button-mobile {
    display: flex !important;
  }
}
</style>
